import _ from 'lodash'

const includeModules = [
  'enjoj\\feed\\SlideshowItem',
  'enjoj\\feed\\UrlItem',
  'enjoj\\feed\\VideoItem',
  'enjoj\\feed\\Menu',
  'enjoj\\feed\\TextualItem',
  'enjoj\\webshop\\Webshop',
  'enjoj\\questionnaire\\Questionnaire',
  'enjoj\\feed\\PdfItem',
  'enjoj\\dates\\DateItem',
  'enjoj\\dates\\Recras'
]

export default class BusinessService {
  constructor (items) {
    this.items = items
  }
  getItems () {
    let items = []

    this.items.forEach((item) => {
      let title = _.kebabCase(item.text)
      if (item.visibility !== 'app' && title !== 'home') {
        if (includeModules.includes(item.type)) {
          items.push(item)
        }
      }
    })

    return items
  }
  getPrivacyStatement () {
    let privacy = this.items.find(item => item.type === 'enjoj\\feed\\PdfItem' && item.text === 'Privacyverklaring')

    return privacy !== undefined ? privacy : null
  }
}
